"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const action_processor_1 = require("./action.processor");
class ClientProcessor extends action_processor_1.ActionProcessor {
    constructor() {
        super(...arguments);
        this.TOKEN = 'token';
        this.NAME = 'name';
        this.FEEDS = 'feeds';
        this.ID = 'id';
        this.LAST_JOB_EXECUTION = 'lastJobExecution';
        this.LAST_JOB_ID = 'lastJobId';
        this.LAST_FILE_ID = 'lastFileId';
        this.LAST_JOB_STATUS = 'lastJobStatus';
    }
    decodeResponseDataItem(responseDataItem) {
        return Object.assign(super.decodeResponseDataItem(responseDataItem), {
            token: responseDataItem[this.TOKEN],
            name: responseDataItem[this.NAME],
            feeds: this.decodeFeeds(responseDataItem)
        });
    }
    decodeFeeds(responseDataItem) {
        const feeds = responseDataItem[this.FEEDS];
        return !!feeds ? feeds.map((feed) => {
            return {
                id: feed[this.ID],
                lastJobExecution: feed[this.LAST_JOB_EXECUTION],
                lastJobId: feed[this.LAST_JOB_ID],
                lastFileId: feed[this.LAST_FILE_ID],
                lastJobStatus: feed[this.LAST_JOB_STATUS]
            };
        }) : {};
    }
}
exports.ClientProcessor = ClientProcessor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpZW50LnByb2Nlc3Nvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9jZXNzb3JzL2NsaWVudC5wcm9jZXNzb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSx5REFBcUQ7QUFFckQscUJBQTZCLFNBQVEsa0NBQWU7SUFBcEQ7O1FBRW1CLFVBQUssR0FBRyxPQUFPLENBQUM7UUFDaEIsU0FBSSxHQUFHLE1BQU0sQ0FBQztRQUNkLFVBQUssR0FBRyxPQUFPLENBQUM7UUFDaEIsT0FBRSxHQUFHLElBQUksQ0FBQztRQUNWLHVCQUFrQixHQUFHLGtCQUFrQixDQUFDO1FBQ3hDLGdCQUFXLEdBQUcsV0FBVyxDQUFDO1FBQzFCLGlCQUFZLEdBQUcsWUFBWSxDQUFDO1FBQzVCLG9CQUFlLEdBQUcsZUFBZSxDQUFDO0lBdUJyRCxDQUFDO0lBckJXLHNCQUFzQixDQUFDLGdCQUFxQjtRQUNwRCxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLHNCQUFzQixDQUFDLGdCQUFnQixDQUFDLEVBQUU7WUFDbkUsS0FBSyxFQUFFLGdCQUFnQixDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7WUFDbkMsSUFBSSxFQUFFLGdCQUFnQixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7WUFDakMsS0FBSyxFQUFFLElBQUksQ0FBQyxXQUFXLENBQUMsZ0JBQWdCLENBQUM7U0FDMUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVPLFdBQVcsQ0FBQyxnQkFBcUI7UUFDdkMsTUFBTSxLQUFLLEdBQUcsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQzNDLE9BQU8sQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQVUsRUFBRSxFQUFFO1lBQ3hDLE9BQU87Z0JBQ0wsRUFBRSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDO2dCQUNqQixnQkFBZ0IsRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLGtCQUFrQixDQUFDO2dCQUMvQyxTQUFTLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUM7Z0JBQ2pDLFVBQVUsRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQztnQkFDbkMsYUFBYSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsZUFBZSxDQUFDO2FBQzFDLENBQUM7UUFDSixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0lBQ1YsQ0FBQztDQUVGO0FBaENELDBDQWdDQyJ9